import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Domnisoara() {
  const IMAGINI = [1, 2, 3, 4, 5].map(n => `/images/domnisoara/${n}.png`);

  return (
    <section>
      <PageHero title="Rochii pentru domnișoara de onoare" subtitle="Palete coordonate, modele variate." />
      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
